<template>
  <div :class="{ card: true, small: small }">
    <div v-for="(entry, i) in someEntries" :key="entry.date || i" class="entry">
      <p class="title is-5 fancy has-text-dark" v-if="entry.date">{{ entry.date }}</p>
      <p
        class="subtitle is-4 has-text-dark"
        v-for="(line, j) in entry.lines"
        :key="line.year || j">
        <span class="subtitle is-6 has-text-grey" v-if="line.year">{{ line.year }}:</span>
        {{ line.text }}
        <span class="has-text-primary" v-for="tag in line.tags" :key="tag">
          #{{ tag }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Notebook',
  props: ['entries', 'small', 'mobileEntry'],
  computed: {
    someEntries() {
      if (this.$mq.above(this.$mv.mobile)) {
        return this.entries
      }

      return [this.entries[this.mobileEntry]]
    }
  }
};
</script>

<style scoped lang="scss">
.entry {
  &:first-of-type {
    margin-top: -7px;
  }

  &:not(:last-of-type) {
    margin-bottom: 30px;
  }

  p {
    line-height: 30px;
  }

  .subtitle,
  .title {
    margin: 0;
  }
}

.card {
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 37px 70px 27px;
  position: relative;
  border: 1px solid #B5B5B5;
  background: white;
  background: linear-gradient(to top, #dfe8ec3d 0%, white 8%) 0 57px;
  background-size: 100% 30px;
  overflow: hidden;

  &:before {
    content:"";
    z-index: -1;
    margin: 0 1px;
    width: 706px;
    height: 10px;
    position: absolute;
    bottom:-3px; left:0;
    background: white;
    border:1px solid #B5B5B5;
  }

  &.small {
    padding-left: 37px;
    padding-right: 20px;

    &:after {
      left: 22px;
    }
  }
}
</style>
